module.exports = __webpack_public_path__ + "img/12.2e1ad691.jpg";